<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Vue Chart Js<small>Input data using mouse or keyboard. <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li>
                    <router-link to="/"> <i class="ti-home"></i></router-link>
                </li>
                <li><a href="#">Charts</a></li>
                <li class="active">Vue Chart Line</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <!-- Default box -->
                    <div class="box">
                        <div class="box-header"> </div>
                        <div class="box-body">
                            <ve-line style="width:100%" :data="chartData" :settings="chartSettings"></ve-line>
                            <ve-line style="width:100%" :data="chartData" :settings="chartSettings"></ve-line>
                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->
    </div>
</template>
<script>
  module.exports = {
    created: function () {
      this.chartData = {type: 'bar',
        columns: ['Linex', 'Sales', 'Cost', 'COGS', 'Waste'],
        rows: [
          { 'Linex': 'Jan', 'Sales': 1, 'Cost': 1, 'COGS': 1, 'Waste': 1 },
          { 'Linex': 'Feb', 'Sales': 2, 'Cost': 2, 'COGS': 2, 'Waste': 2 },
          { 'Linex': 'Mar', 'Sales': 3, 'Cost': 3, 'COGS': 3, 'Waste': 3 },
          { 'Linex': 'Apr', 'Sales': 4, 'Cost': 4, 'COGS': 4, 'Waste': 4 },
          { 'Linex': 'Mei', 'Sales': 5, 'Cost': 5, 'COGS': 5, 'Waste': 5 },
          { 'Linex': 'Jun', 'Sales': 6, 'Cost': 6, 'COGS': 6, 'Waste': 6 },
          { 'Linex': 'Jul', 'Sales': 7, 'Cost': 7, 'COGS': 7, 'Waste': 7 },
          { 'Linex': 'Ags', 'Sales': 8, 'Cost': 8, 'COGS': 8, 'Waste': 8 },
          { 'Linex': 'Sep', 'Sales': 9, 'Cost': 9, 'COGS': 9, 'Waste': 9 },
          { 'Linex': 'Okt', 'Sales': 10, 'Cost': 10, 'COGS': 10, 'Waste': 10 },
          { 'Linex': 'Nop', 'Sales': 11, 'Cost': 11, 'COGS': 11, 'Waste': 11 },
          { 'Linex': 'Des', 'Sales': 12, 'Cost': 12, 'COGS': 12, 'Waste': 50 }
        ]
      }
      this.chartSettings = {
        stack: { 'Price': ['Sales', 'Cost', 'COGS', 'Waste'] },
        area: true
      }
      // this.chartSettings = {
      //   area: true
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// ChartJs.vue?7d416d90